import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';

import { CHANGE_LANGUAGE_FORM_NAME } from 'constants/logic';
import { Card, CardTitle } from 'components/Card';
import { Fieldset, RadioButton } from 'components/Form';
import Message from 'components/Message';

const messages = defineMessages({
  additionalLanguages: {
    id: 'settings.change-language-form-section.additional-languages-title',
    defaultMessage: 'Additional languages',
  },
  additionalLanguagesDescription: {
    id: 'settings.change-language-form-section.additional-languages-description',
    defaultMessage: 'More languages will be available in the future.',
  },
  title: {
    id: 'settings.change-language-form-section.title',
    defaultMessage: 'Change language',
  },
  translation: {
    id: 'settings.change-language-form-section.translation-title',
    defaultMessage: 'Translation',
  },
  translationDescription: {
    id: 'settings.change-language-form-section.translation-description',
    defaultMessage:
      'We’ll translate the most important information for your browsing, and booking. Our translations are provided for your convenience. The English version of ClassPass, including our Conditions of Use, is the definitive version.',
  },
});

export const ChangeLanguageSection = ({ languages, handleChangeLocale }) => (
  <Card>
    <Message as={CardTitle} message={messages.title} />
    <div className="grid grid--rev">
      <div className="grid__item md-2/3">
        <div className="md-ml+">
          <div className="mb+">
            <Message as="h5" className="epsilon mb-" message={messages.translation} />
            <Message as="p" message={messages.translationDescription} />
          </div>
          <div>
            <Message as="h5" className="epsilon mb-" message={messages.additionalLanguages} />
            <Message as="p" message={messages.additionalLanguagesDescription} />
          </div>
        </div>
      </div>
      <div className="grid__item md-1/3">
        <Fieldset>
          {languages.map(({ id, name }) => (
            <Field
              name="locale"
              component={RadioButton}
              value={id}
              type="radio"
              key={id}
              onChange={() => handleChangeLocale(id)}>
              {name && <Message message={name} />}
            </Field>
          ))}
        </Fieldset>
      </div>
    </div>
  </Card>
);

ChangeLanguageSection.propTypes = {
  handleChangeLocale: PropTypes.func,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string,
      }),
    })
  ),
};

const mapStateToProps = (state, { currentLocale }) => ({
  initialValues: {
    locale: currentLocale,
  },
});

const ChangeLanguageFormSection = compose(
  connect(mapStateToProps),
  reduxForm({
    form: CHANGE_LANGUAGE_FORM_NAME,
  })
)(ChangeLanguageSection);

export default ChangeLanguageFormSection;
